import { type ReactNode } from 'react';
import { cn } from '@/shared/utils/utils';
import { Button } from '@/shared/components/ui/Button';

interface ChipOption {
  value: string;
  label: string;
  icon?: ReactNode;
  activeColor?: {
    bg: string;
    text: string;
    border: string;
    iconColor?: string;
  };
}

interface ChipToggleProps {
  options: ChipOption[];
  value: string;
  onChange: (value: string) => void;
}

export const ChipToggle = ({ options, value, onChange }: ChipToggleProps) => {
  return (
    <div className="flex gap-0.5">
      {options.map((option) => {
        const isActive = value === option.value;
        return (
          <Button
            key={option.value}
            variant="ghost"
            onClick={() => onChange(option.value)}
            className={cn(
              'h-auto gap-1.5 px-2.5 py-1 text-[13px] font-medium text-muted-foreground transition-all duration-[120ms] border border-transparent',
              'hover:bg-muted hover:text-foreground',
              isActive && option.activeColor
                ? `${option.activeColor.bg} ${option.activeColor.text} ${option.activeColor.border}`
                : isActive && 'bg-muted text-foreground border-border'
            )}
          >
            {option.icon && (
              <span
                className={cn(
                  'inline-flex items-center opacity-50 [&>svg]:w-3.5 [&>svg]:h-3.5',
                  isActive && option.activeColor?.iconColor
                    ? `opacity-80 ${option.activeColor.iconColor}`
                    : isActive && 'opacity-80'
                )}
              >
                {option.icon}
              </span>
            )}
            {option.label}
          </Button>
        );
      })}
    </div>
  );
};
